<template>
  <p :class="getClass()">{{ 'work-stock.states.' + this.status | translate }}</p>
</template>

<script>
import { WorkStockItemStates } from '@/resources/models/work-stock-item';

export default {
  name: 'WorkStockStatus',
  props: {
    status: String,
    isButton: Boolean,
    disabled: Boolean
  },
  methods: {
    getClass () {
      let result = '';
      if (this.status === WorkStockItemStates.New) {
        result = 'work-stock-status new';
      } else if (this.status === WorkStockItemStates.Reviewing) {
        result = 'work-stock-status reviewing';
      } else if (this.status === WorkStockItemStates.Closed) {
        result = 'work-stock-status closed';
      } else {
        result = 'work-stock-status';
      }
      if (this.isButton) {
        result += ' is-button';

        if (this.disabled) {
          result += ' disabled';
        }
      }
      return result;
    }
  }
};
</script>

<style lang='scss' scoped>
@import '@/assets/stylesheets/variables.scss';

.work-stock-status {
  border-radius: $border-radius;
  padding: 4px 9px;
  font-weight: 600;
  display: inline-block;
  position: relative;

  background-color: $gray;
  color: $primary;
  white-space: nowrap;

  &.new {
    background-color: $positive-lighten-3;
    color: $positive;
  }

  &.reviewing {
    background-color: $secondary-lighten-4;
    color: $secondary;
  }

  &.closed {
    background-color: $positive;
    color: white;
  }

  &.is-button {
    padding: 12px 14px;
    cursor: pointer;

    &.disabled {
      background-color: white;

      box-shadow: inset 0px 0px 0px 1px $gray;
      color: $primary-lighten-1;
    }
  }
}
</style>
